import React from 'react';
import {
  Dialog,
  Box,
  Typography,
  withStyles,
  createStyles,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import IconsButton from '../../../shared/Buttons/IconsButton';
import DeleteRoleActionButtons from '../ActionButtons/DeleteRoleActionButtons';
import { ADMIN_ROLE_DELETE_SUBMIT } from '../../../../constants/analytics';
import { analyticsTrackEvent } from '../../../../utils/analytics';

const styles = () =>
  createStyles({
    dialog: {
      display: 'flex',
      flexDirection: 'column',
      gap: '24px',
      width: '600px',
      padding: '24px 16px',
      boxSizing: 'border-box',
    },
    dialogTitle: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
    },
    dialogTitleHeader: {
      color: 'rgba(0, 0, 0, 0.87)',
      fontSize: '1.25rem',
      fontWeight: 500,
      lineHeight: '150%',
    },

    contentText: {
      padding: '0px',
      color: 'rgba(0, 0, 0, 1)',
      fontSize: '0.875rem',
      fontWeight: 400,
      lineHeight: '150%',
    },
  });

class Delete extends React.Component<any> {
  handleClose = () => {
    this.props.handleClose();
  };

  handleSubmit = async () => {
    const result = await this.props.deleteRole(this.props.roleId);
    // Only close dialog if deletion was successful
    if (result?.success) {
      // Fire ADMIN_ROLE_DELETE_SUBMIT event before dialog close
      analyticsTrackEvent(ADMIN_ROLE_DELETE_SUBMIT, {
        role_id: this.props.roleId,
        role_name: this.props.roleName,
      });
      this.handleClose();
    }
  };

  render() {
    const { roleName, classes } = this.props;

    return (
      <Dialog
        open={this.props.open}
        onClose={this.handleClose}
        aria-labelledby="delete-role-dialog-title"
        fullWidth
      >
        <Box className={classes.dialog}>
          <Box id="delete-role-dialog-title" className={classes.dialogTitle}>
            <Typography className={classes.dialogTitleHeader}>
              Delete Role
            </Typography>
            <IconsButton handleClick={this.handleClose} icon={CloseIcon} />
          </Box>
          <Box>
            <Typography className={classes.contentText}>
              Are you sure you want to delete the <strong>{roleName}</strong>{' '}
              from the list?
              <br />
              Deleting the role will remove access from the user.
            </Typography>
          </Box>

          <DeleteRoleActionButtons
            handleSubmit={this.handleSubmit}
            handleClose={this.handleClose}
          />
        </Box>
      </Dialog>
    );
  }
}

export default withStyles(styles)(Delete);
